import { v4 } from 'uuid';
import filter from 'lodash/filter';
import find from 'lodash/find';
import findIndex from 'lodash/findIndex';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import reject from 'lodash/reject';
import some from 'lodash/some';

import {
  ADD_BLOCK_TO_CANVAS,
  ADD_EDGE_TO_CANVAS,
  ADD_NEW_INTEGRATION,
  BULK_GRAPH_MANIPULATION,
  DELETE_CANVAS_SUCCESS,
  DELETE_PLAN_INTEGRATION_SUCCESS,
  FD_EDIT_FORM,
  FD_EDIT_INTEGRATION_COMMIT,
  FD_EDIT_INTEGRATION_END,
  FD_EDIT_INTEGRATION_START,
  FD_SET_FORM_TRIGGER_INTEGRATION,
  FD_UPDATE_EDIT_FORM,
  FETCH_PLAN_INTEGRATIONS_SUCCESS,
  FETCH_BUILT_IN_INPUTS,
  FETCH_BUILT_IN_INPUTS_FAIL,
  FETCH_BUILT_IN_INPUTS_SUCCESS,
  FETCH_FLOWS_FAIL,
  FETCH_FLOWS_START,
  FETCH_FLOWS_SUCCESS,
  FETCH_FORM_RESPONSES_SUCCESS,
  FETCH_INITIAL_BLOCKS_BY_CANVAS_SUCCESS,
  FETCH_INITIAL_CANVAS_BY_PLAN_SUCCESS,
  FETCH_INITIAL_CANVAS_EMBEDS_DATA_SUCCESS,
  FETCH_INITIAL_EDGES_BY_CANVAS_SUCCESS,
  FETCH_INITIAL_INPUTS_BY_CANVAS_SUCCESS,
  FETCH_INTEGRATION_STEPS_SUCCESS,
  FLOW_DESIGNER_ADD_BLOCK_HIGHLIGHT,
  FLOW_DESIGNER_CLOSE,
  FLOW_DESIGNER_DUPLICATE_BLOCK,
  FLOW_DESIGNER_LEAVE_WORKFLOW,
  FLOW_DESIGNER_REBUILD_PLAN_CANVAS,
  FLOW_DESIGNER_REMOVE_BLOCK_HIGHLIGHT,
  FLOW_DESIGNER_SAVE_START,
  FLOW_DESIGNER_SAVE_FINISH,
  FLOW_DESIGNER_SWITCH_BLOCK_MODIFY,
  FLOW_DESIGNER_SWITCH_CASE_ADD,
  FLOW_DESIGNER_SWITCH_CASE_MODIFY,
  FLOW_DESIGNER_SWITCH_CASE_REMOVE,
  FLOW_DESIGNER_UPDATE_BLOCK_PRESENTATION,
  FLOW_DESIGNER_UPDATE_EDGE_CONNECT_HIGHLIGHT,
  FLOW_DESIGNER_UPDATE_BLOCK_STEP,
  FLOW_DESIGNER_UPDATE_BLOCK_LABEL,
  FLOW_DESIGNER_UPDATE_BLOCK_PORTS,
  FLOW_FETCH_FORM_SECTIONS_ADD_AUTOMATION,
  FLOW_FETCH_FORM_SECTIONS_SUCCESS,
  FLOW_SET_CANVAS_DIRTY,
  INCIDENT_TRIGGERS_CHANGED,
  LOAD_CANVAS_BY_PLAN_FAIL,
  LOAD_CANVAS_BY_PLAN_FINISHED,
  LOAD_CANVAS_BY_PLAN_START,
  LOAD_CANVAS_BY_PLAN_SUCCESS,
  MARK_INTEGRATION_DELETED,
  REMOVE_BLOCK_FROM_CANVAS,
  REMOVE_EDGE_FROM_CANVAS,
  SAVE_CANVAS_BY_PLAN_FAIL,
  SAVE_CANVAS_BY_PLAN_SUCCESS,
  SAVE_PLAN_INTEGRATION_FAIL,
  SAVE_PLAN_INTEGRATION_SUCCESS,
  UPDATE_CANVAS_MINIMAL_SUCCESS,
  UPDATE_PLAN_INTEGRATION,
  SET_BLOCK_CONDITION_PATHS,
} from 'actions/flowDesigner';

import { SET_INCIDENT_PROPERTIES } from 'actions/flowDesigner/getIncidentStep';

import { ADD_PROPERTY_AS_INPUT } from 'actions/flowDesigner/xmUpdateIncidentStep';

import {
  FETCH_SCRIPT_STEP_SUCCESS,
  FETCH_SCRIPT_STEPS_SUCCESS,
  FETCH_SCRIPT_STEP_PERMISSIONS_SUCCESS,
  SAVE_SCRIPT_STEP_PERMISSIONS_SUCCESS,
} from 'actions/flowDesigner/scriptSteps';

import {
  FBI_EDIT_CHANGE_VERSION,
  FBI_EDIT_RESTORE_SAVED_INPUTS_AND_ENDPOINTS,
  FBI_EDIT_START,
  FBI_ENDPOINT_SELECTED,
  FBI_FETCH_ALL_AGENTS_SUCCESS,
  FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE_SUCCESS,
  FBI_HTTP_TRIGGER_CHANGE_VERSION,
  FBI_HTTP_TRIGGER_RESTORE_VERSION,
  FBI_MERGE_BLOCK_COMMIT,
  FBI_MERGE_BLOCK_COMMIT_INPUTS_AND_OUTPUTS,
  FBI_SET_CREATE_EVENT_BLOCK_FORM_ID,
  FBI_VALUE_CHANGED,
  FLOW_BLOCK_ENVIRONMENT_CHANGED,
  FLOW_BLOCK_LABEL_CHANGED,
  FLOW_RUN_LOCATION_AGENTS_CHANGED,
  IB_ENDPOINT_CREATED,
} from 'actions/flowBlockInput';
import { FBI_SET_INITIATE_INCIDENT_BLOCK_INCIDENT_TYPE_SUCCESS } from 'actions/flowDesigner/initiateIncidentStep';
import {
  CREATE_FORM_SUCCESS,
  CREATE_FORM_SECTION_START,
  CREATE_FORM_SECTION_SUCCESS,
  REFETCH_BLOCK_INPUTS_SUCCESS,
} from 'actions/flowDesigner/canvas';
import * as featureTogglesActions from 'actions/featureToggles';

import {
  VALIDATE_FETCH_LAYOUT_FOR_LIST_VALIDATION_SUCCESS,
  VALIDATE_RECEIVED_FORM_PROPERTIES,
  FETCH_INCIDENT_TYPES_AND_PROPERTIES_SUCCESS,
} from 'actions/flowValidations';

import { unpackPagedData } from 'reducers/utils';
import {
  isTemplateStepType,
  prepareApiInputs,
  prepareEdgeForJsPlumbNesting,
} from 'utils/flow';
import { correctTriggerPositions } from 'utils/flow/initiateIncident';
import {
  isFlowIntegration,
  MODIFIABLE_INTEGRATION_FIELDS,
} from 'utils/integrations';
import { syncCreateAlertInputData } from 'utils/flowBlockInput';
import { FlowInputId, mockBuiltinInputs } from 'xm-constants/flowInput';
import {
  isFormBasedTrigger,
  scriptStepTypes,
} from '@xmatters/common/constants/scriptSteps';

import keyBy from 'lodash/keyBy';
import forEach from 'lodash/forEach';
import { AuthMethodTypes } from 'utils/authMethodTypes';
import isEqual from 'lodash/isEqual';
import { buildConditionPathsByBlockId } from 'utils/conditionPaths';
import {
  addUnsavedUsageToCustomSteps,
  buildFlowList,
  buildPlanCanvas,
  buildPlanCanvasAndIntegration,
  duplicateBlock,
  duplicateBlockEndpoint,
  duplicateConditionPaths,
  duplicateInputs,
  duplicateIntegration,
  duplicateMergeStepOutputs,
  duplicateIncidentProperties,
  duplicateSwitchCases,
  getRemovedIntegrationsState,
  getIncidentPropertiesByBlockId,
  makeFlowBlockInput,
  mergeUnsavedUsageInCustomSteps,
  removeIntegrations,
  removeUnsavedUsageInCustomSteps,
  transformBlocksData,
  transformStepData,
  transformStepsData,
  updateIntegration,
  upsertById,
} from './utils';

import {
  handleBlockEndpointChanges,
  handleBlockInputChanges,
  handleFlowChanges,
} from './canvasChangeUpdator';

import { changeVersion } from './blockVersionChangeHander';
import { automationOutput } from './triggerOutputs';
import syncDynamicBlockInputs from './syncDynamicBlockInputs';

const RESTORE_SAVED_INPUTS_EXCLUDE = {
  [scriptStepTypes.CREATE_ALERT]: [
    FlowInputId.ALERT_EMAIL,
    FlowInputId.ALERT_SMS,
    FlowInputId.ALERT_VOICE,
  ],
};

const getDefaultState = () => ({
  isCanvasDirty: false,
  isSaving: false,
  customSteps: [],
  data: [],
  planId: undefined,
  canvasId: undefined,
  forms: [],
  modifiedForms: [],
  planCanvas: undefined,
  usedFlowId: undefined,
  allCanvases: [],
  allValidations: {},
  integrationSteps: [],
  responses: [],
  endpoints: [],
  inputs: [],
  savedInputs: [],
  savedFlowBlockStep: null,
  savedEditingBlock: null,
  flows: [],
  flowsStatus: null,
  editIntegrationId: null,
  switchCases: [],
  formSections: [],
  layoutByFormIdMap: {},
  mergeOutputs: [],
  isIncidentManagementEnabled: false,
  isEndpointTypeChanged: false,
  // Integrations as saved in the API (do not change except when API returns data!):
  apiIntegrations: [],
  // Current integrations state on the client (will be diffed against apiIntegrations when deciding what to delete/update/create):
  uiIntegrations: [],
  isAutomationTrigger: false, // after loading form panel sections, we will add automation if isAutomationTrigger is true
});

const setDefaultInputValue = ({
  inputs,
  stepInputs,
  blockId,
  stepType = null,
}) => {
  return filter(
    stepInputs,
    csi =>
      !some(
        inputs,
        i => i.flowBlock.id === blockId && i.scriptStepInput?.id === csi.id,
      ),
  ).map(csi => {
    /** This limitation is only for Create Risk Event component
    if OPTIONAL input value of Create Risk Event component was saved for the block, 
    we don't want to override with default value and want to keep it empty. 
    Backend doesn't want to keep empty values in the DB */
    const isEverbridgeStepOptionalInput =
      stepType === 'EVERBRIDGE' &&
      some(inputs, i => i.flowBlock.id === blockId) &&
      !csi?.required;
    return makeFlowBlockInput(
      blockId,
      csi,
      !isEverbridgeStepOptionalInput ? csi?.defaultValue : null,
    );
  });
};

const makeSwitchStepInput = (blockId, value = '') => ({
  id: v4(),
  flowBlock: { id: blockId },
  inputPort: 'input',
  value,
});

function getClearedFlowDesignerState(state) {
  const {
    allCanvases,
    forms,
    flows,
    flowsStatus,
    customSteps,
    isIncidentManagementEnabled,
  } = state;

  const returnVal = {
    ...getDefaultState(),
    // State required for flowList. TODO: have a separate reducer for flowList, treat it as
    // a separate page compared to the editor modal, since they're wholely different UI.
    allCanvases,
    customSteps: (customSteps || []).filter(
      c => c.scriptStepType === scriptStepTypes.CUSTOM_HTTP,
    ),
    forms,
    flows,
    flowsStatus,
    isIncidentManagementEnabled,
  };

  return returnVal;
}

export default function flowDesigner(currentState = getDefaultState(), action) {
  const state = handleFlowChanges(currentState, action);
  const { type, payload } = action;

  const getUpdatedCanvas = newProps =>
    buildPlanCanvas({
      ...state,
      ...(state.planCanvas || {}),
      ...newProps,
    });

  const updateBlockInState = (
    stateToUpdate,
    blockId,
    changedData,
    markCanvasDirty = true,
  ) => {
    const { blocks } = stateToUpdate.planCanvas;
    const updatedBlocks = upsertById(blocks, blockId, block => ({
      ...block,
      ...changedData,
    }));

    const planCanvas = getUpdatedCanvas({
      blocks: updatedBlocks,
    });

    return {
      ...stateToUpdate,
      blocks: planCanvas.blocks,
      planCanvas,
      isCanvasDirty: markCanvasDirty || stateToUpdate.isCanvasDirty,
    };
  };

  switch (type) {
    case FLOW_DESIGNER_CLOSE: {
      return getClearedFlowDesignerState(state);
    }
    case FLOW_SET_CANVAS_DIRTY: {
      return {
        ...state,
        isCanvasDirty: !!payload.isDirty,
      };
    }
    case FLOW_DESIGNER_LEAVE_WORKFLOW: {
      return {
        ...getDefaultState(),
        // Only keeping application-level data (so far just feature toggles). Ideally, longer term, these
        // should not even be in this reducer, they should be accessed from the correct state paths downstream:
        isIncidentManagementEnabled: state.isIncidentManagementEnabled,
      };
    }
    case 'FLOW_DESIGNER_LOAD_APPLICATION':
      return {
        ...state,
        plan: action.payload,
      };
    case FETCH_INITIAL_CANVAS_BY_PLAN_SUCCESS:
      return {
        ...state,
        allCanvases: payload.data,
      };
    case FETCH_INITIAL_BLOCKS_BY_CANVAS_SUCCESS:
      return {
        ...state,
        blocks: transformBlocksData(payload.data),
      };
    case FETCH_INITIAL_EDGES_BY_CANVAS_SUCCESS:
      return {
        ...state,
        edges: map(payload.data, prepareEdgeForJsPlumbNesting),
      };
    case VALIDATE_RECEIVED_FORM_PROPERTIES: {
      return syncDynamicBlockInputs(state);
    }
    case FETCH_INCIDENT_TYPES_AND_PROPERTIES_SUCCESS: {
      const incidentTypes = action.payload.data;
      return syncDynamicBlockInputs({ ...state, incidentTypes });
    }
    case FETCH_INITIAL_INPUTS_BY_CANVAS_SUCCESS: {
      // (!) this action loads the API response of /flow-block-inputs endpoint into the redux store;
      // this endpoint returns data only if the user has enterred data (string or pill) into the
      // input field of a flow block editor.
      // Chunks of that are overwritten by LOAD_CANVAS_BY_PLAN_SUCCESS
      // which is called soon after
      return {
        ...state,
        inputs: prepareApiInputs(payload),
      };
    }
    case REFETCH_BLOCK_INPUTS_SUCCESS: {
      const { planCanvas, customSteps, blocks } = state;
      const { blockId } = action.payload;
      const block = blocks.find(b => b.id === blockId);
      if (!block) {
        return state;
      }
      let blockInputs = prepareApiInputs(payload);

      const customStep = customSteps.find(step => step.id === block.step.id);
      if (customStep?.inputs) {
        blockInputs = [
          ...blockInputs,
          ...setDefaultInputValue({
            inputs: blockInputs,
            stepInputs: customStep.inputs.data,
            blockId: block.id,
          }),
        ];
      }
      const updatedInputs = [
        ...planCanvas.inputs.filter(input => input.flowBlock.id !== blockId),
        ...blockInputs,
      ];
      return {
        ...state,
        planCanvas: {
          ...planCanvas,
          inputs: updatedInputs,
        },
        inputs: updatedInputs,
      };
    }
    case FETCH_INITIAL_CANVAS_EMBEDS_DATA_SUCCESS: {
      return {
        ...state,
        switchCases: payload.switchCases.data,
        mergeOutputs: payload.mergeOutputs.data,
        planCanvas: {
          ...state.planCanvas,
          conditionPathsByBlockId: buildConditionPathsByBlockId(
            payload?.conditionPaths?.data ?? [],
          ),
          incidentProperties: getIncidentPropertiesByBlockId(
            payload.dynamicOutputs.data,
          ),
        },
      };
    }
    case FETCH_PLAN_INTEGRATIONS_SUCCESS: {
      const integrations = (payload.data || []).map(integration =>
        updateIntegration(integration),
      );

      return {
        ...state,
        apiIntegrations: integrations,
        uiIntegrations: [...integrations],
      };
    }
    case LOAD_CANVAS_BY_PLAN_START: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case LOAD_CANVAS_BY_PLAN_FINISHED: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case LOAD_CANVAS_BY_PLAN_FAIL: {
      return {
        ...state,
        planCanvas: payload,
      };
    }
    case FBI_MERGE_BLOCK_COMMIT_INPUTS_AND_OUTPUTS: {
      const { outputs, inputs, blockId } = payload;
      const { planCanvas } = state;

      // Update Merge Outputs:
      const irrelevantOutputs = planCanvas.mergeOutputs.filter(
        output => output.block.id !== blockId,
      );
      const updatedOutputs = [...irrelevantOutputs, ...outputs];

      // Update Inputs:
      const irrelevantInputs = planCanvas.inputs.filter(
        input => input.flowBlock?.id !== blockId,
      );
      const updatedInputs = [...irrelevantInputs, ...inputs];

      return {
        ...state,
        planCanvas: {
          ...planCanvas,
          mergeOutputs: updatedOutputs,
          inputs: updatedInputs,
        },
      };
    }
    case SET_INCIDENT_PROPERTIES: {
      const { planCanvas } = state;
      const { incidentProperties } = planCanvas;

      return {
        ...state,
        planCanvas: {
          ...planCanvas,
          incidentProperties: {
            ...incidentProperties,
            [payload.flowBlockId]: payload.propertyIds,
          },
        },
      };
    }

    case ADD_PROPERTY_AS_INPUT: {
      const { planCanvas } = state;
      const { inputs } = planCanvas;
      const { propertyIds, flowBlockId } = payload;

      const updatedInputs = inputs.map(input => {
        if (
          input.scriptStepInput.name === 'Input Mappings' &&
          input.flowBlock.id === flowBlockId
        ) {
          const values = propertyIds.map(({ name, description }) => ({
            name,
            value: description,
          }));
          return {
            ...input,
            value: JSON.stringify(values),
          };
        }
        return input;
      });

      return {
        ...state,
        planCanvas: {
          ...planCanvas,
          inputs: updatedInputs,
        },
      };
    }

    case FBI_MERGE_BLOCK_COMMIT: {
      const { blockInputs, blockOutputs, label, mergeId } = payload;
      const { planCanvas } = state;

      // Update Merge Outputs:
      const irrelevantOutputs = planCanvas.mergeOutputs.filter(
        output => output.block.id !== mergeId,
      );
      const updatedOutputs = [...irrelevantOutputs, ...blockOutputs];

      // Update Inputs:
      const irrelevantInputs = planCanvas.inputs.filter(
        input => input.flowBlock?.id !== mergeId,
      );
      const updatedInputs = [...irrelevantInputs, ...blockInputs];

      const updatedBlocks = map([...planCanvas.blocks], block =>
        block.id === mergeId ? { ...block, label } : block,
      );

      return {
        ...state,
        planCanvas: {
          ...planCanvas,
          mergeOutputs: updatedOutputs,
          inputs: updatedInputs,
          blocks: updatedBlocks,
        },
        // values in 👆planCanvas are canonical/truth
        // we're just updated the following as a nicety
        mergeOutputs: updatedOutputs,
        inputs: updatedInputs,
        blocks: updatedBlocks,
        isCanvasDirty: true,
      };
    }
    case LOAD_CANVAS_BY_PLAN_SUCCESS: {
      const { planId, canvas } = payload;
      const { customSteps } = state;
      const blocks = transformBlocksData(state.blocks || canvas.blocks);
      let inputs = state.inputs || canvas.inputs;

      if (blocks) {
        // fill input with default values if it is not loaded from the server
        const stepIdToStepMap = new Map(customSteps.map(s => [s.id, s]));
        const sblocks = blocks.filter(
          b =>
            b.step &&
            (b.step.type === scriptStepTypes.SCRIPT_STEP ||
              b.scriptStep?.dynamicConfigEnabled),
        );
        sblocks.forEach(sb => {
          const scriptStepId = sb.scriptStep?.id || sb.step.id;
          const step = stepIdToStepMap.get(scriptStepId);
          if (step) {
            inputs = [
              ...inputs,
              ...setDefaultInputValue({
                inputs,
                stepInputs: step.inputs.data,
                blockId: sb.id,
                stepType: step.builtInType,
              }),
            ];
          }
        });
      }

      const updatedPlanCanvas = { ...state.planCanvas, ...canvas };

      updatedPlanCanvas.blocks = blocks;

      const syncDynamicBlockInputsState = syncDynamicBlockInputs({
        ...state,
        inputs,
        planCanvas: {
          ...updatedPlanCanvas,
          blocks,
          inputs,
        },
      });
      inputs = syncDynamicBlockInputsState.inputs;

      inputs = syncCreateAlertInputData({
        blocks,
        builtInInputs: state.builtInInputs,
        inputs,
      });

      const [planCanvas, uiIntegrations] = buildPlanCanvasAndIntegration({
        ...state,
        inputs,
        planCanvas: updatedPlanCanvas,
        planId,
        switchCases: state.switchCases,
        mergeOutputs: state.mergeOutputs,
      });

      return {
        ...state,
        uiIntegrations,
        planId,
        canvasId: canvas.id,
        planCanvas,
        isCanvasDirty: false,
        endpoints: blocks
          ? blocks
              .filter(b => b.endpoint != null && b.endpoint.id != null)
              .map(b => ({
                flowBlockId: b.id,
                endpoint: b.endpoint,
              }))
          : [],
        inputs,
      };
    }
    case SAVE_CANVAS_BY_PLAN_FAIL: {
      return {
        ...state,
        isSaving: false,
      };
    }
    case SAVE_CANVAS_BY_PLAN_SUCCESS: {
      const {
        allCanvases: oldCanvases,
        planCanvas,
        forms,
        apiIntegrations,
        customSteps,
      } = state;

      const responseBlocks = keyBy(payload.blocks.data, 'id');
      const savedCanvas = { ...planCanvas };
      savedCanvas.initial = false;
      savedCanvas.blocks = savedCanvas.blocks.map(block => {
        const { isGeneratedForLegacyIntegration, ...blockProps } = block;
        const newBlock = isGeneratedForLegacyIntegration ? blockProps : block;
        // Note: in the case of template step, the step information can
        // change when the canvas is saved to reference an instance of the step template
        // instead of the template step
        if (isTemplateStepType(block.step.type)) {
          const responseStep = responseBlocks[block.id]?.step ?? {};
          return {
            ...newBlock,
            step: { ...newBlock.step, ...responseStep },
          };
        }

        return newBlock;
      });

      // Insert newly saved canvas into Flow List data:
      const allCanvases = upsertById(
        oldCanvases,
        planCanvas.id,
        () => savedCanvas,
      );
      const flows = buildFlowList(forms, allCanvases, apiIntegrations);

      return {
        ...state,
        allCanvases,
        planCanvas: savedCanvas,
        blocks: savedCanvas.blocks,
        customSteps: mergeUnsavedUsageInCustomSteps(customSteps),
        flows,
        uiIntegrations: [...apiIntegrations],
        isCanvasDirty: false,
      };
    }
    case FLOW_DESIGNER_SAVE_START: {
      return {
        ...state,
        isSaving: true,
      };
    }
    case FLOW_DESIGNER_SAVE_FINISH: {
      return {
        ...state,
        isSaving: false,
      };
    }
    case FETCH_INTEGRATION_STEPS_SUCCESS: {
      return {
        ...state,
        integrationSteps: transformStepsData(payload.data),
      };
    }
    case FETCH_SCRIPT_STEPS_SUCCESS: {
      const customSteps = transformStepsData(payload.data);
      return {
        ...state,
        customSteps,
      };
    }
    case FETCH_SCRIPT_STEP_SUCCESS: {
      return {
        ...state,
        customSteps: upsertById(
          state.customSteps || [],
          payload.id,
          transformStepData(payload),
        ),
      };
    }
    case FETCH_SCRIPT_STEP_PERMISSIONS_SUCCESS: {
      const { stepId, ...permitted } = payload;

      const customStep = state.customSteps.find(step => step.id === stepId);

      return {
        ...state,
        customSteps: upsertById(state.customSteps || [], stepId, {
          ...customStep,
          permitted,
        }),
      };
    }
    case SAVE_SCRIPT_STEP_PERMISSIONS_SUCCESS: {
      const { id, permitted, owner, ownerSupervisors, accessibleByAll } =
        payload;
      const customStep = state.customSteps.find(step => step.id === id);
      return {
        ...state,
        customSteps: upsertById(state.customSteps || [], id, {
          ...customStep,
          permitted,
          owner,
          ownerSupervisors,
          accessibleByAll,
        }),
      };
    }
    case FETCH_BUILT_IN_INPUTS_SUCCESS:
    case FETCH_BUILT_IN_INPUTS_FAIL:
    case FETCH_BUILT_IN_INPUTS: {
      // TODO: update when the `/built-in-inputs` endpoint is implemented:
      const builtInInputs = mockBuiltinInputs;
      const newState = {
        ...state,
        builtInInputs,
      };

      // Inject built in inputs for Create Alert blocks, if blocks are loaded already:
      if (state.planCanvas?.blocks) {
        newState.planCanvas = {
          ...state.planCanvas,
          inputs: syncCreateAlertInputData({
            blocks: state.planCanvas.blocks,
            builtInInputs,
            inputs: state.inputs,
          }),
        };
        newState.inputs = newState.planCanvas.inputs;
      }

      return newState;
    }
    case FBI_VALUE_CHANGED: {
      return {
        ...handleBlockInputChanges(state, action.payload),
      };
    }
    case FBI_ENDPOINT_SELECTED: {
      return handleBlockEndpointChanges(state, action.payload);
    }
    case FBI_SET_INITIATE_INCIDENT_BLOCK_INCIDENT_TYPE_SUCCESS: {
      return syncDynamicBlockInputs(state);
    }
    case FBI_FETCH_LAYOUT_FOR_CREATE_EVENT_INPUTS_UPDATE_SUCCESS: {
      const { formId, data } = action.payload;
      return syncDynamicBlockInputs({
        ...state,
        planLayoutByFormId: {
          ...state.planLayoutByFormId,
          [formId]: data,
        },
      });
    }
    case FBI_SET_CREATE_EVENT_BLOCK_FORM_ID: {
      const { flowBlockId, formId, label } = action.payload;
      const updateBlockWithForm = block => {
        if (block.id !== flowBlockId) {
          return block;
        }
        return {
          ...block,
          label: label || block.label,
          step: {
            ...block.step,
            id: formId,
          },
        };
      };

      const updatedState = syncDynamicBlockInputs({
        ...state,
        planCanvas: {
          ...state.planCanvas,
          blocks: state.planCanvas.blocks.map(updateBlockWithForm),
        },
      });
      // TODO: FUTURE: We shouldn't hold and sync two copies of blocks. Remove `state.flowDesigner.blocks`.
      updatedState.blocks = updatedState.planCanvas.blocks;
      return updatedState;
    }
    case FLOW_BLOCK_LABEL_CHANGED: {
      const { flowBlockId, label } = action;
      // Update planCanvas in case the label changes affected any other details.
      // E.g. Changing a Create Alert block's label also changes its subtrigger block labels:
      return updateBlockInState(state, flowBlockId, { label });
    }
    case FETCH_FLOWS_START: {
      return {
        ...getClearedFlowDesignerState(state),
        flows: [],
        flowsStatus: 'LOADING',
      };
    }
    case FETCH_FLOWS_SUCCESS: {
      const {
        forms,
        integrations,
        flowCanvases,
        planType,
        id: flowId,
      } = payload;
      const formsData = unpackPagedData(forms);
      const integrationsData = (unpackPagedData(integrations) || []).map(
        integration => updateIntegration(integration),
      );
      const allCanvases = unpackPagedData(flowCanvases).map(canvas => ({
        ...canvas,
        blocks: canvas.blocks?.data,
      }));
      const flows = buildFlowList(formsData, allCanvases, integrationsData);

      return {
        ...state,
        allCanvases,
        planType,
        flows,
        apiIntegrations: integrationsData,
        uiIntegrations: [...integrationsData],
        forms: formsData,
        flowsStatus: 'SUCCESS',
        usedFlowId: flowId,
      };
    }
    case FETCH_FLOWS_FAIL: {
      return {
        ...state,
        flows: [],
        flowsStatus: 'FAIL',
      };
    }
    case UPDATE_CANVAS_MINIMAL_SUCCESS: {
      const { id, name, description, plan } = payload;
      const updator = oldData => ({
        ...oldData,
        id,
        name,
        description,
        plan,
        blocks: oldData?.blocks || [],
      });
      const allCanvases = upsertById(state.allCanvases, id, updator);
      const flows = buildFlowList(
        state.forms,
        allCanvases,
        state.uiIntegrations,
      );

      return {
        ...state,
        allCanvases,
        flows,
      };
    }
    case DELETE_CANVAS_SUCCESS: {
      const { id } = payload;
      const { allCanvases, apiIntegrations: prevIntegrations } = state;

      // xm-api removes all integrations related to the blocks
      const prevCanvas = allCanvases.find(c => c.id === id);
      const blocksByStepId = groupBy(prevCanvas.blocks, 'step.id');
      const isDeletedIntegration = integration =>
        isFlowIntegration(integration) && !!blocksByStepId[integration.id];
      const apiIntegrations = reject(prevIntegrations, isDeletedIntegration);

      return {
        ...state,
        allCanvases: allCanvases.filter(c => c.id !== id),
        flows: buildFlowList(state.forms, allCanvases, apiIntegrations),
        apiIntegrations,
        uiIntegrations: [...apiIntegrations],
      };
    }
    case ADD_BLOCK_TO_CANVAS: {
      const { block, inputNameValueMap } = payload;
      const {
        step: { type: stepType },
        scriptStep,
      } = block;

      // This change comes with an xmApi change making the "scriptStep" property
      // available on the "block" object
      // In the case of triggers, the "step.id" maps to an integration,
      // but we want the actual scriptStep object (with its inputs)
      // for the dynamicCongigEnabled steps.
      // This allows the flowDesigner.planCanvas.inputs to be populated with the right inputs
      const stepId = scriptStep?.id || block.step.id;

      const step =
        state.customSteps.find(cs => cs.id === stepId) ||
        state.integrationSteps.find(is => is.id === stepId) ||
        state.uiIntegrations.find(is => is.id === stepId);

      const updatedCustomSteps = addUnsavedUsageToCustomSteps(
        state.planCanvas,
        state.customSteps,
        stepId,
      );

      let runEnvironment = step && step.allowedEnvironment;
      if (step && !runEnvironment) {
        runEnvironment = step.environment;
      }

      let newBlock = block;
      if (step) {
        newBlock = { ...block, environment: runEnvironment };
      }

      const blocks = [...state.planCanvas.blocks, newBlock];

      // Prepare inputs for the default values, when applicable:
      let inputs = state.inputs || [];
      if (step && step.inputs) {
        inputs = [
          ...inputs,
          ...setDefaultInputValue({
            inputs,
            stepInputs: step.inputs.data,
            blockId: block.id,
          }),
        ];
      } else if (stepType === scriptStepTypes.SWITCH) {
        inputs = [...state.planCanvas.inputs, makeSwitchStepInput(block.id)];
      } else if (stepType === scriptStepTypes.CREATE_ALERT) {
        inputs = syncCreateAlertInputData({
          // Just an efficiency helper: only add for the newest block:
          blocks: [newBlock],
          builtInInputs: state.builtInInputs,
          inputs: state.planCanvas.inputs,
        });
      }

      // set any inputs values that were passed in
      const blockInputsByName = keyBy(
        filter(inputs, i => i.flowBlock.id === newBlock.id),
        'scriptStepInput.name',
      );
      forEach(inputNameValueMap, (value, inputName) => {
        const input = blockInputsByName[inputName];
        if (input) {
          input.value = value;
        }
      });

      // Rebuild canvas with new blocks and new inputs:
      const [planCanvas, uiIntegrations] = buildPlanCanvasAndIntegration({
        ...state,
        ...state.planCanvas,
        blocks,
        edges: state.planCanvas.edges,
        inputs,
      });

      return {
        ...state,
        blocks: planCanvas.blocks,
        customSteps: updatedCustomSteps,
        planCanvas,
        inputs,
        uiIntegrations,
        isCanvasDirty: true,
      };
    }
    case REMOVE_BLOCK_FROM_CANVAS: {
      const { block } = payload;
      const { planCanvas } = state;

      const blocksToRemove = planCanvas.blocks.filter(
        b => b.id === block.id || b.groupingBlockId === block.id,
      );
      const mergeOutputs = planCanvas.mergeOutputs.filter(
        o => o.block.id !== block.id,
      );

      const updatedState = getRemovedIntegrationsState({
        blocksToRemove,
        getUpdatedCanvas,
        state,
      });

      const updatedCustomSteps = removeUnsavedUsageInCustomSteps(
        updatedState.planCanvas.blocks,
        state.canvasId,
        state.customSteps,
        block.step.id,
      );

      let { incidentProperties } = state.planCanvas;
      if (incidentProperties[block.id]) {
        incidentProperties = { ...incidentProperties };
        delete incidentProperties[block.id];
      }

      let { conditionPathsByBlockId } = state.planCanvas;
      if (conditionPathsByBlockId[block.id]) {
        conditionPathsByBlockId = { ...conditionPathsByBlockId };
        delete conditionPathsByBlockId[block.id];
      }

      return {
        ...updatedState,
        planCanvas: {
          ...updatedState.planCanvas,
          mergeOutputs,
          conditionPathsByBlockId,
          incidentProperties,
        },
        customSteps: updatedCustomSteps,
        mergeOutputs,
        isCanvasDirty: true,
      };
    }
    case ADD_EDGE_TO_CANVAS: {
      const { edge } = payload;
      const { planCanvas: oldCanvas } = state;
      // Already exists on canvas:
      if (find(oldCanvas.edges, oldEdge => oldEdge.id === edge.id)) {
        return state;
      }
      const edges = [...oldCanvas.edges, edge];
      const planCanvas = getUpdatedCanvas({ edges });

      return {
        ...state,
        planCanvas,
        edges,
        isCanvasDirty: true,
      };
    }
    case REMOVE_EDGE_FROM_CANVAS: {
      const { edgeId } = payload;
      const { planCanvas: oldCanvas } = state;
      const edges = filter(oldCanvas.edges, e => e.id !== edgeId);

      return {
        ...state,
        planCanvas: getUpdatedCanvas({ edges }),
        edges,
        isCanvasDirty: true,
      };
    }
    case BULK_GRAPH_MANIPULATION: {
      const { edgesToAdd, edgeIdsToRemove, blockPositions } = payload;
      const { planCanvas: oldCanvas } = state;
      let { blocks, edges } = oldCanvas;

      // Update edges:
      if (edgeIdsToRemove?.length) {
        const edgeIdsToRemoveSet = new Set(edgeIdsToRemove);
        edges = filter(oldCanvas.edges, e => !edgeIdsToRemoveSet.has(e.id));
      }
      if (edgesToAdd?.length) {
        edges = edges.concat(edgesToAdd);
      }

      // Update blocks:
      if (blockPositions) {
        const blockPositionById = keyBy(blockPositions, 'id');
        blocks = blocks.map(block => {
          const updatedBlockPosition = blockPositionById[block.id];
          return updatedBlockPosition
            ? {
                ...block,
                presentation: {
                  ...block.presentation,
                  x: updatedBlockPosition.x ?? block.presentation.x,
                  y: updatedBlockPosition.y ?? block.presentation.y,
                },
              }
            : block;
        });
      }

      if (blocks === oldCanvas.blocks && edges === oldCanvas.edges) {
        // Nothing ultimately changed:
        return state;
      }
      const planCanvas = getUpdatedCanvas({ edges, blocks });

      return {
        ...state,
        planCanvas,
        edges: planCanvas.edges,
        blocks: planCanvas.blocks,
        isCanvasDirty: true,
      };
    }
    case ADD_NEW_INTEGRATION: {
      const newIntegration = payload.integration;

      if (!newIntegration.name.endsWith(` - ${newIntegration.id}`)) {
        newIntegration.name = `${newIntegration.name} - ${newIntegration.id}`;
      }

      return {
        ...state,
        uiIntegrations: [...state.uiIntegrations, newIntegration],
      };
    }
    case MARK_INTEGRATION_DELETED: {
      const { blocks, blockIds } = payload;
      let blocksToRemove = blocks ? [...blocks] : [];
      if (blockIds?.length) {
        const blockIdsSet = new Set(payload.blockIds || []);
        blocksToRemove = [
          ...blocksToRemove,
          ...state.planCanvas.blocks.filter(b => blockIdsSet.has(b.id)),
        ];
      }
      return {
        ...getRemovedIntegrationsState({
          blocksToRemove,
          getUpdatedCanvas,
          state,
        }),
        isCanvasDirty: true,
      };
    }
    case FETCH_FORM_RESPONSES_SUCCESS: {
      return {
        ...state,
        responses: payload.data,
      };
    }
    case DELETE_PLAN_INTEGRATION_SUCCESS: {
      const { id } = payload;

      return {
        ...state,
        apiIntegrations: removeIntegrations(state.apiIntegrations, id),
      };
    }
    case SAVE_PLAN_INTEGRATION_SUCCESS: {
      const savedIntegration = updateIntegration(payload);
      const { id } = savedIntegration;
      const prevIntegs = state.apiIntegrations || [];

      return {
        ...state,
        apiIntegrations: upsertById(prevIntegs, id, savedIntegration),
        uiIntegrations: upsertById(state.uiIntegrations, id, savedIntegration),
        savedIntegration,
      };
    }
    case SAVE_PLAN_INTEGRATION_FAIL: {
      // TODO: figure out how we're supposed to handle this in here, if at all?
      return state;
    }
    case UPDATE_PLAN_INTEGRATION: {
      const { id, props } = payload;
      const nonModifiableField = Object.keys(props).find(
        field => !MODIFIABLE_INTEGRATION_FIELDS.includes(field),
      );
      if (nonModifiableField) {
        throw new Error(
          `Updated integration field, "${nonModifiableField}", is not included in MODIFIABLE_INTEGRATION_FIELDS.
           Integration change will not be persisted when saving the canvas! `,
        );
      }

      const { uiIntegrations } = state;
      const integration = uiIntegrations.find(
        uiIntegration => uiIntegration.id === id,
      );
      const updatedIntegration = { ...integration, ...props };

      return {
        ...state,
        uiIntegrations: upsertById(
          state.uiIntegrations,
          id,
          updatedIntegration,
        ),
        isCanvasDirty: true,
      };
    }
    case IB_ENDPOINT_CREATED: {
      const endpoints = state.endpoints ? [...state.endpoints] : [];
      const { flowBlockId, id } = action.payload;
      const endpoint = {
        id,
      };
      const prevIndex = findIndex(
        endpoints,
        e => e.flowBlockId === flowBlockId,
      );
      const index = prevIndex === -1 ? endpoints.length : prevIndex;
      endpoints[index] = { flowBlockId, endpoint };
      const newState = {
        ...state,
        endpoints,
      };

      return handleBlockEndpointChanges(newState, { flowBlockId, endpoint });
    }
    case FBI_EDIT_START: {
      const { flowBlockId, uuid } = action.payload;
      const savedInputs = state.inputs;
      const savedEndpoints = state.endpoints;
      const step =
        state.customSteps.find(cs => cs.id === uuid) ||
        state.integrationSteps.find(is => is.id === uuid);
      let inputs = state.inputs || [];
      if (step) {
        inputs = [
          ...inputs,
          ...setDefaultInputValue({
            inputs,
            stepInputs: step.inputs.data,
            blockId: flowBlockId,
          }),
        ];
      }

      const editingBlock = {
        ...state.blocks.find(b => b.id === flowBlockId),
      };
      const editingBlockStep = editingBlock.step;
      const savedEditStep = editingBlockStep
        ? { id: editingBlockStep.id, type: editingBlockStep.type }
        : null;
      return {
        ...state,
        editIntegrationId: flowBlockId,
        inputs,
        savedInputs,
        savedEndpoints,
        savedFlowBlockStep: step,
        savedEditingBlock: {
          ...editingBlock,
          step: savedEditStep,
        },
        planCanvas: getUpdatedCanvas({ inputs }),
      };
    }
    case FBI_EDIT_CHANGE_VERSION: {
      return changeVersion(state, action);
    }
    case FBI_HTTP_TRIGGER_CHANGE_VERSION: {
      const newStep = action.version;
      const integrationId = state.editIntegrationId;
      if (newStep && integrationId) {
        const index = findIndex(
          state.uiIntegrations,
          i => i.id === integrationId,
        );
        const getUpdated = (integ = {}) => ({
          ...integ,
          authenticationType:
            newStep.triggerAuthType === integ.authenticationType ||
            newStep.triggerAuthType === AuthMethodTypes.ALLOW_ALL
              ? integ.authenticationType
              : newStep.triggerAuthType,
          environment: newStep.allowedEnvironment,
          scriptStep: {
            id: newStep.id,
          },
        });

        if (index >= 0) {
          const updatedIntegration = getUpdated(state.uiIntegrations[index]);
          const uiIntegrations = [...state.uiIntegrations];
          uiIntegrations[index] = updatedIntegration;

          return {
            ...state,
            uiIntegrations,
          };
        }
      }
      return state;
    }
    case FBI_HTTP_TRIGGER_RESTORE_VERSION: {
      const { savedIntegration, uiIntegrations } = state;
      if (savedIntegration) {
        const restoredInputs = [...state.planCanvas.inputs];
        const { flowBlockInputs } = savedIntegration;
        if (flowBlockInputs) {
          // flowBlockInputs are added to flowDesigner.savedIntegration strictly for the purpose
          // of knowing what value to put back on cancel in the FD integration editor
          flowBlockInputs.forEach(restorableInput => {
            const index = state.planCanvas.inputs.findIndex(
              i => i.scriptStepInput.id === restorableInput.scriptStepInput.id,
            );
            restoredInputs[index] = restorableInput;
          });
        }
        return {
          ...state,
          uiIntegrations: uiIntegrations.map(integration =>
            integration.id === savedIntegration.id
              ? savedIntegration
              : integration,
          ),
          savedIntegration: null,
          planCanvas: {
            ...state.planCanvas,
            inputs: restoredInputs,
          },
          inputs: restoredInputs,
        };
      }
      return state;
    }
    case FBI_EDIT_RESTORE_SAVED_INPUTS_AND_ENDPOINTS: {
      const { editIntegrationId, inputs, savedInputs } = state;

      const isExcludedInput = input => {
        if (input?.flowBlock?.id !== editIntegrationId) {
          return false;
        }

        const { name, builtInType } = input?.scriptStepInput ?? {};
        return (
          RESTORE_SAVED_INPUTS_EXCLUDE[builtInType] &&
          RESTORE_SAVED_INPUTS_EXCLUDE[builtInType].includes(name)
        );
      };

      const newInputs = savedInputs.filter(input => !isExcludedInput(input));
      newInputs.push(...inputs.filter(input => isExcludedInput(input)));

      const newState = {
        ...state,
        inputs: newInputs,
        endpoints: state.savedEndpoints,
        savedInputs: [],
        savedEndpoints: [],
        savedFlowBlockStep: null,
      };

      const restoreBlockStepId = block =>
        block.id !== state.savedEditingBlock.id
          ? block
          : state.savedEditingBlock;

      // restore the editing blockStepId for cancelled version changes
      const restoredBlocks = newState.planCanvas.blocks.map(restoreBlockStepId);
      const planCanvas = buildPlanCanvas({
        ...newState,
        blocks: restoredBlocks,
        edges: newState.planCanvas.edges,
      });
      newState.planCanvas = planCanvas;
      newState.blocks = restoredBlocks;

      return newState;
    }
    case FD_EDIT_INTEGRATION_START: {
      const integration = state.uiIntegrations.find(
        i => i.id === action.payload.integrationId,
      );
      // temporarily saving the opened dialog's flow block inputs into flowDesigner.savedIntegration
      // so that they can be restored on cancel.
      // The 'flowBlockInputs' key gets nuked either on SAVE_PLAN_INTEGRATION_SUCCESS
      // or after it has served its purpose in FBI_HTTP_TRIGGER_RESTORE_VERSION
      // where it gets nuked along with the rest of 'savedIntegration'
      const flowBlockInputs = state.planCanvas.inputs.filter(
        i => i.flowBlock.id === action.payload.flowBlockId,
      );

      const newState = {
        ...state,
        editIntegrationId: action.payload.integrationId,
        savedIntegration: {
          ...integration,
          flowBlockInputs,
        },
      };

      if (
        integration &&
        integration.form &&
        isFormBasedTrigger(integration.operation)
      ) {
        const editForm = (state.forms || []).find(
          f => f.id === integration.form.id,
        );
        if (editForm) {
          const preModified = state.modifiedForms || [];
          const modifiedForms = upsertById(preModified, editForm.id, editForm);
          newState.modifiedForms = modifiedForms;
          newState.editFormId = null;
        }
      }
      return newState;
    }
    case FD_EDIT_INTEGRATION_COMMIT: {
      const {
        id,
        name,
        form,
        deployed,
        runAsUser,
        runAsTriggerUser,
        preventDuplicateEbIncidentResponses,
        triggerId,
        environment,
        authenticationType,
        script,
        agents,
        triggerFilter,
        service,
        isRunByServiceOwner,
        sharedAutomation,
      } = action.payload;

      if (id) {
        const uiIntegrations = state.uiIntegrations
          ? [...state.uiIntegrations]
          : [];
        const index = findIndex(uiIntegrations, i => i.id === id);
        const getUpdated = (integ = {}) => ({
          ...integ,
          id,
          name: `${name} - ${id}`,
          form,
          deployed,
          triggerId,
          environment,
          authenticationType,
          script,
          agents,
          runAs: runAsUser,
          runAsTriggerUser,
          preventDuplicateEbIncidentResponses,
          triggerFilter,
          service,
          isRunByServiceOwner,
          sharedAutomation,
        });

        if (index >= 0) {
          const nameChanged = name !== uiIntegrations[index].name;
          uiIntegrations[index] = getUpdated(uiIntegrations[index]);

          let { planCanvas } = state;
          let { blocks } = planCanvas;
          const existingBlock = (blocks || []).find(
            b => b.step && b.step.id === id,
          );
          const blockId = existingBlock ? existingBlock.id : id;

          if (nameChanged) {
            blocks = upsertById(blocks, blockId, (block = {}) => ({
              ...block,
              label: name,
            }));

            planCanvas = getUpdatedCanvas({
              blocks,
              edges: planCanvas.edges,
              inputs: planCanvas.inputs,
            });
          }

          return {
            ...state,
            uiIntegrations,
            blocks,
            planCanvas,
            isCanvasDirty: true,
          };
        }
      }
      return state;
    }
    case FD_EDIT_INTEGRATION_END: {
      return {
        ...state,
        editIntegrationId: null,
        formSections: [],
      };
    }
    case FLOW_DESIGNER_SWITCH_BLOCK_MODIFY: {
      const { blockId, label, property } = payload;
      const blocks = upsertById(state.planCanvas.blocks, blockId, block => ({
        ...block,
        label,
      }));

      const inputs = [...state.planCanvas.inputs];
      const inputValue = property ? `$\{${property}}` : null;
      const inputIndex = findIndex(
        inputs,
        ({ flowBlock }) => flowBlock.id === blockId,
      );
      if (inputIndex === -1) {
        inputs.push(makeSwitchStepInput(blockId, inputValue));
      } else {
        inputs[inputIndex].value = inputValue;
      }

      const planCanvas = getUpdatedCanvas({ blocks, inputs });

      return {
        ...state,
        planCanvas,
        blocks: planCanvas.blocks,
        inputs,
        isCanvasDirty: true,
      };
    }
    case FLOW_DESIGNER_SWITCH_CASE_ADD: {
      const { blockId, orderNum, value } = payload;
      const newCase = {
        value,
        id: v4(),
        block: { id: blockId },
        orderNum,
      };
      const switchCases = [...state.switchCases, newCase];
      const planCanvas = getUpdatedCanvas({ switchCases });

      return {
        ...state,
        planCanvas,
        blocks: planCanvas.blocks,
        switchCases,
        isCanvasDirty: true,
      };
    }
    case FLOW_DESIGNER_SWITCH_CASE_REMOVE: {
      const { id } = payload;
      const switchCases = reject(state.switchCases, { id });

      const isCaseEdge = ({ from: { port, block } }) =>
        port === id || block.id.indexOf(id) > 0;
      const edges = reject(state.planCanvas.edges, isCaseEdge);

      const planCanvas = getUpdatedCanvas({
        edges,
        switchCases,
      });

      return {
        ...state,
        planCanvas,
        blocks: planCanvas.blocks,
        edges: planCanvas.edges,
        switchCases,
        isCanvasDirty: true,
      };
    }
    case FLOW_DESIGNER_SWITCH_CASE_MODIFY: {
      const { id, value } = payload;
      const update = caseObj => ({ ...caseObj, value });
      const switchCases = upsertById(state.switchCases, id, update);
      const planCanvas = getUpdatedCanvas({ switchCases });

      return {
        ...state,
        planCanvas,
        blocks: planCanvas.blocks,
        switchCases,
        isCanvasDirty: true,
      };
    }
    case SET_BLOCK_CONDITION_PATHS: {
      const { blockId, conditionPaths, markCanvasDirty, updateEdges } = payload;
      const blockConditionPaths = conditionPaths.map((path, index) => ({
        ...path,
        orderNum: index + 1,
        block: {
          id: blockId,
        },
        config: {
          version: '1',
          ...path.config,
        },
      }));

      const existingConditionPaths =
        state.planCanvas.conditionPathsByBlockId[blockId];
      // note: do not unnecessarily trigger validation if nothing changed
      if (
        !markCanvasDirty &&
        isEqual(blockConditionPaths, existingConditionPaths)
      ) {
        return state;
      }

      let { planCanvas } = state;
      if (updateEdges) {
        const { edges } = planCanvas;

        const otherEdges = edges.filter(
          edge => !edge.from.block.id.startsWith(blockId),
        );
        const blockEdges = edges
          .filter(edge => edge.from.block.id.startsWith(blockId))
          // filter removed edges
          .filter(
            edge =>
              edge.from.port === 'output' ||
              blockConditionPaths.some(
                conditionPath => conditionPath.id === edge.from.port,
              ),
          );

        planCanvas = getUpdatedCanvas({
          edges: [...otherEdges, ...blockEdges],
        });
      }

      return {
        ...state,
        planCanvas: {
          ...planCanvas,
          conditionPathsByBlockId: {
            ...planCanvas.conditionPathsByBlockId,
            [blockId]: blockConditionPaths,
          },
        },
        edges: planCanvas.edges,
        blocks: planCanvas.blocks,
        isCanvasDirty: state.isCanvasDirty || markCanvasDirty,
      };
    }
    case FLOW_DESIGNER_REBUILD_PLAN_CANVAS: {
      return {
        ...state,
        planCanvas: getUpdatedCanvas({}),
      };
    }
    case FLOW_BLOCK_ENVIRONMENT_CHANGED: {
      const { flowBlockId, environment } = payload;
      const flowBlock = state.planCanvas.blocks.find(b => b.id === flowBlockId);

      const hasIntegration = state.uiIntegrations.some(
        i => i.id === flowBlock.step.id,
      );
      const uiIntegrations = hasIntegration
        ? upsertById(state.uiIntegrations, flowBlock.step.id, integration => ({
            ...integration,
            environment,
          }))
        : state.uiIntegrations;

      const updatedCanvas = getUpdatedCanvas({
        blocks: upsertById(state.planCanvas.blocks, flowBlockId, block => ({
          ...block,
          environment,
        })),
        uiIntegrations,
      });

      return {
        ...state,
        planCanvas: updatedCanvas,
        uiIntegrations,
        blocks: updatedCanvas.blocks,
      };
    }
    case FLOW_RUN_LOCATION_AGENTS_CHANGED: {
      const { flowBlockId, selectedAgents } = payload;
      const newData = { agents: selectedAgents || [] };
      return updateBlockInState(state, flowBlockId, newData);
    }

    case FBI_FETCH_ALL_AGENTS_SUCCESS: {
      if (typeof action.payload.data !== 'undefined') {
        const agents = action.payload.data;
        return {
          ...state,
          xagents: agents,
        };
      }
      return {
        ...state,
        xagents: [],
      };
    }
    case FD_SET_FORM_TRIGGER_INTEGRATION: {
      const existingIntegrations = state.uiIntegrations;
      const toUpdate = existingIntegrations.find(
        integration => integration.id === action.flowBlockId,
      );
      // Update the form associated with this integration
      const newIntegration = { ...toUpdate, form: { id: action.formId } };
      const uiIntegrations = upsertById(
        existingIntegrations,
        action.flowBlockId,
        newIntegration,
      );
      return { ...state, uiIntegrations };
    }
    case FLOW_FETCH_FORM_SECTIONS_ADD_AUTOMATION: {
      return { ...state, isAutomationTrigger: !!payload };
    }
    case FLOW_FETCH_FORM_SECTIONS_SUCCESS: {
      const { isAutomationTrigger } = state;
      const formSections = isAutomationTrigger
        ? [automationOutput, ...payload.data]
        : payload.data;
      return { ...state, formSections };
    }
    case FD_EDIT_FORM: {
      const form = payload;
      const preModified = state.modifiedForms || [];
      const modifiedForms = upsertById(preModified, form.id, form);
      return { ...state, modifiedForms, editFormId: form.id };
    }
    case FD_UPDATE_EDIT_FORM: {
      const { id, uiEnabled, mobileEnabled } = payload;
      const preModified = state.modifiedForms || [];
      const modified = preModified.find(m => m.id === id);
      if (modified) {
        modified.uiEnabled = uiEnabled;
        modified.mobileEnabled = mobileEnabled;
        const modifiedForms = upsertById(preModified, id, modified);
        return { ...state, modifiedForms };
      }
      return state;
    }
    case VALIDATE_FETCH_LAYOUT_FOR_LIST_VALIDATION_SUCCESS: {
      const { formId, data } = action.payload;
      return {
        ...state,
        planLayoutByFormId: {
          ...state.planLayoutByFormId,
          [formId]: data,
        },
      };
    }
    case featureTogglesActions.LOAD_SUCCESS: {
      const featureMap = action.payload.data.reduce(
        (acc, { name, value }) => ({
          ...acc,
          [name]: value,
        }),
        {},
      );
      return {
        ...state,
        isIncidentManagementEnabled:
          featureMap.INCIDENT_MANAGEMENT_MVP === 'true',
      };
    }
    case INCIDENT_TRIGGERS_CHANGED: {
      // If the position values behave unexpectedly, check other places that mutates it
      // in other places of the repo (such as ./utils.js).
      // We really shouldn't be mutating the state object in any way; hopefully we can correct it in the future.
      const planCanvas = {
        ...state.planCanvas,
        incidentTriggers: {
          ...state.planCanvas.incidentTriggers,
          [payload.flowBlockId]: correctTriggerPositions(payload.value),
        },
      };

      return {
        ...state,
        planCanvas,
        isCanvasDirty: true,
      };
    }
    case FLOW_DESIGNER_DUPLICATE_BLOCK: {
      const { blockId, intl, blockLabelBuilder, stepType, xOffset, yOffset } =
        payload;
      const { inputs, blocks, conditionPathsByBlockId, incidentProperties } =
        state.planCanvas;
      const { endpoints, uiIntegrations, switchCases, mergeOutputs } = state;

      const block = blocks.find(flowBlock => flowBlock.id === blockId);

      const duplicatedBlock = duplicateBlock({
        block,
        stepType,
        xOffset,
        yOffset,
        blockLabelBuilder,
        intl,
      });
      const { id: duplicatedBlockId } = duplicatedBlock;

      const duplicatedEndpoint = duplicateBlockEndpoint({
        endpoints,
        duplicatedBlockId,
        blockId,
      });

      const duplicatedSwitchCases = duplicateSwitchCases({
        switchCases,
        blockId,
        duplicatedBlockId,
        stepType,
      });

      const duplicatedConditionPaths = duplicateConditionPaths({
        conditionPathsByBlockId,
        blockId,
      });

      const duplicatedMergeStepOutputs = duplicateMergeStepOutputs({
        mergeOutputs,
        stepType,
        blockId,
        duplicatedBlockId,
      });

      const duplicatedIncidentProperties = duplicateIncidentProperties({
        incidentProperties,
        blockId,
        duplicatedBlockId,
        block,
      });

      const duplicatedInputs = duplicateInputs({
        inputs,
        blockId,
        duplicatedBlockId,
        stepType,
      });

      const duplicatedIntegration = duplicateIntegration({
        integrations: uiIntegrations,
        stepType,
        stepId: block.step?.id,
      });

      if (duplicatedIntegration) {
        // keep the block label and the integration name in sync
        duplicatedBlock.label = duplicatedIntegration.name;
        duplicatedBlock.step.id = duplicatedIntegration.id;
      }

      const planCanvas = getUpdatedCanvas({
        blocks: [...blocks, duplicatedBlock],
        inputs: duplicatedInputs ? [...inputs, ...duplicatedInputs] : inputs,
        switchCases: duplicatedSwitchCases
          ? [...switchCases, ...duplicatedSwitchCases]
          : switchCases,
        mergeOutputs: duplicatedMergeStepOutputs
          ? [...mergeOutputs, ...duplicatedMergeStepOutputs]
          : mergeOutputs,
      });
      if (duplicatedConditionPaths) {
        planCanvas.conditionPathsByBlockId = {
          ...conditionPathsByBlockId,
          [duplicatedBlockId]: duplicatedConditionPaths,
        };
      }
      if (duplicatedIncidentProperties) {
        planCanvas.incidentProperties = {
          ...incidentProperties,
          [duplicatedBlockId]: duplicatedIncidentProperties,
        };
      }

      return {
        ...state,
        isCanvasDirty: true,
        planCanvas,
        uiIntegrations: duplicatedIntegration
          ? [...uiIntegrations, duplicatedIntegration]
          : uiIntegrations,
        switchCases: duplicatedSwitchCases
          ? [...switchCases, ...duplicatedSwitchCases]
          : switchCases,
        mergeOutputs: duplicatedMergeStepOutputs
          ? [...mergeOutputs, ...duplicatedMergeStepOutputs]
          : mergeOutputs,
        blocks: [...blocks, duplicatedBlock],
        inputs: duplicatedInputs ? [...inputs, ...duplicatedInputs] : inputs,
        endpoints: duplicatedEndpoint
          ? [...endpoints, duplicatedEndpoint]
          : endpoints,
      };
    }
    case FLOW_DESIGNER_UPDATE_BLOCK_PRESENTATION: {
      const { id, presentation } = payload;
      return updateBlockInState(state, id, { presentation });
    }
    case FLOW_DESIGNER_UPDATE_BLOCK_STEP: {
      const { id, step } = payload;
      return updateBlockInState(state, id, { step });
    }
    case FLOW_DESIGNER_UPDATE_BLOCK_LABEL: {
      const { id, label } = payload;
      return updateBlockInState(state, id, { label });
    }
    case FLOW_DESIGNER_UPDATE_BLOCK_PORTS: {
      const { id, ports, markCanvasDirty } = payload;
      return { ...updateBlockInState(state, id, { ports }, markCanvasDirty) };
    }
    case FLOW_DESIGNER_ADD_BLOCK_HIGHLIGHT: {
      return updateBlockInState(state, payload, {
        isDuplicateHighlightVisible: true,
      });
    }
    case FLOW_DESIGNER_REMOVE_BLOCK_HIGHLIGHT: {
      return updateBlockInState(state, payload, {
        isDuplicateHighlightVisible: false,
      });
    }
    case FLOW_DESIGNER_UPDATE_EDGE_CONNECT_HIGHLIGHT: {
      const edgeConnectHighlight = payload;
      if (isEqual(edgeConnectHighlight, state.edgeConnectHighlight)) {
        return state;
      }
      return {
        ...state,
        edgeConnectHighlight,
      };
    }
    case CREATE_FORM_SUCCESS: {
      // Don't want recipients, scenarios & responseOptions to be saved to the server later.
      // Server would return a 400.
      const { recipients, scenarios, responseOptions, ...newForm } =
        action.payload;

      return {
        ...state,
        forms: [...state.forms, newForm],

        // So we can save disabled/enabled right after the form was created.
        modifiedForms: [...(state.modifiedForms || []), newForm],

        // So we can edit permissions right after the form was created.
        editFormId: newForm.id,
      };
    }
    case CREATE_FORM_SECTION_START:
      return {
        ...state,
        isAutomationTrigger: action.payload.isAutomation,
      };
    case CREATE_FORM_SECTION_SUCCESS: {
      const { isAutomationTrigger } = state;
      const formSections = isAutomationTrigger
        ? [...state.formSections, automationOutput, action.payload]
        : [...state.formSections, action.payload];

      return {
        ...state,
        formSections,
      };
    }
    default:
      return state;
  }
}
